<template lang="pug">
  .main(v-if="content")
    .main__sections
        MenuSide(:menu="content.menuItems")
        .main__sections-bg
        .page__wr
            SectionOne.slide(:section1="content.contents[0]" :data-id="content.menuItems[0].id")
            SectionTwo.slide(:section2="content.contents[1]" :data-id="content.menuItems[1].id")
            SectionThree.slide(:section3="content.contents[2]" :data-id="content.menuItems[2].id")
            SectionFour.slide(:section4="content.contents[3]" :data-id="content.menuItems[3].id")
            SectionFive.slide(:section5="content.contents[4]" :data-id="content.menuItems[4].id")
            SectionSix.slide(:section6="content.contents[5]" :data-id="content.menuItems[5].id")
            SectionSeven.slide(:section7="content.contents[6]" :data-id="content.menuItems[6].id")
</template>

<script>
import EventBus from '@/eventBus';

import '@/components/main/main.styl';
import SectionOne from '@/components/main/section1/SectionOne.vue';
import SectionTwo from '@/components/main/section2/SectionTwo.vue';
import SectionThree from '@/components/main/section3/SectionThree.vue';
import SectionFour from '@/components/main/section4/SectionFour.vue';
import SectionFive from '@/components/main/section5/SectionFive.vue';
import SectionSix from '@/components/main/section6/SectionSix.vue';
import SectionSeven from '@/components/main/section7/SectionSeven.vue';
import MenuSide from '@/components/main/menuSide/MenuSide.vue';
import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';
import {SlideHelpers} from '@/mixins/SlideHelpers';

// @ is an alias to /src
//import Events from '@/components/events/Events.vue';

export default {
  name: 'Main',

  mixins: [AjaxHelpersVue, SlideHelpers],

  data() {
    return {
      content: null,
      contents: null,
      objImages: [],
    }
  },

  components: {
    SectionOne,
    SectionTwo,
    SectionThree,
    SectionFour,
    SectionFive,
    SectionSix,
    SectionSeven,
    MenuSide
  },

  created() {
    // Загрузка данных для страницы
      this.$nextTick(() => {
          // this.request(this.$router.currentRoute.path);
      });
  },

  mounted() {
      this.$nextTick(() => {
          setTimeout(() => {
              this.slideTop();
          }, 400);
      });
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
        // экземпляр компонента доступен как `vm`
        EventBus.$emit('pagePreloaderShow');
        vm.scrollbarCheck();
        setTimeout(() => {
            EventBus.$emit('setMenuTopActiveClass', to.path);
            vm.request(to.path);
        }, 50);
    })
  },

  beforeRouteUpdate(to, from, next) {
      EventBus.$emit('pagePreloaderShow');
      this.scrollbarCheck();
      setTimeout(() => {
          EventBus.$emit('setMenuTopActiveClass', to.path);
          this.request(to.path);
          next();
      }, 50);
  },

  methods: {
    request(url) {
      this.req('MainPage:getMainPage', {url}, res => {
        this.content = res.content;
        this.contents = this.content.contents;
        this.objImages = this.objImages.concat({loaded: false, url: this.contents[0].image.path});
        this.objImages = this.objImages.concat({loaded: false, url: this.contents[1].image.path});
        this.objImages = this.objImages.concat({loaded: false, url: this.contents[4].image.path});
        this.objImages = this.objImages.concat({loaded: false, url: this.contents[5].image.path});
        for(let i = 0; i < this.contents[2].slider.length; i++) {
          this.objImages = this.objImages.concat({loaded: false, url: this.contents[2].slider[i].path})
        }
        for(let i = 0; i < this.contents[3].slider.length; i++) {
          this.objImages = this.objImages.concat({loaded: false, url: this.contents[3].slider[i].path})
        }
        this.checkImgLoading(this.objImages);
        EventBus.$emit('pagePreloaderHide');
        this.$nextTick(() => {
            if($(window).width() > 760) {
                this.initSlide();
            }
            this.changeStyle();
            this.checkOverflow(url);
            let src = '/img/background.png';
            let $img = $('<img src="' + src + '">');
            $img.bind( 'load', function(){
                if($('.slide--show').attr('data-id') == 7) {
                    $('.main__sections-bg').css({'background-image': 'url(' + src + ')'});
                }
                else {
                    $('.main__sections-bg').css({'background-image': 'url(' + src + ')', 'opacity': '1'});
                }
            } );
            if( $img[0].width ){ $img.trigger( 'load' ); }
        });
      });
    },
    slideTop () {
        $('.header__top-left').on('click', () => {
            this.setSlide(1, 'prev');
        });
    }
    /*popupLocal(type, action) {
      this.popup(type, action);
    }*/
  }

}
</script>
